import { useEffect } from 'react';

export const SITE_NAME = 'Definitionofthe.com';
export const SITE_URL = 'https://definitionofthe.com';

// Every route is served by the same index.html, so each page sets its own
// <title> and meta description for search results and shared links.
export const usePageMeta = (title, description) => {
  useEffect(() => {
    if (title) document.title = title;

    if (description) {
      let meta = document.querySelector('meta[name="description"]');
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute('name', 'description');
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', description);
    }
  }, [title, description]);
};
